import newColorAxiosInstance from "@/common-components-src/api/new-color-axiosInstance";
import { PointsList, pointsType, Response } from './index.api';

//用户积分余额
export const fetchGetPointsBalance = (params: { pointsType: number }):Promise<Response<any>> => {
    return newColorAxiosInstance
    .post('user_points_queryPointsBalance',undefined)
    .then((response: any) => response.data)
    .catch((err: any) => err);
}

//用户积分流水查询
export const fetchGetPointsQuery =(params:pointsType):Promise<PointsList> =>{
    return newColorAxiosInstance
    .post<Response<PointsList>>('user_points_queryPointsRecord',undefined,{params})
    .then((response: any) => response.data)
    .catch((err: any) => err);
}